/**
 * Cliente para enviar plantillas transaccionales de correo de seguimiento
 * desde el CallSidebar y administrar el texto de "Promociones del mes".
 *
 * Backend: `app/api/endpoints/crm/follow_up_emails.py` (migrofast),
 * plantillas HTML en `app/templates/emails/follow_up_*.html`.
 *
 * Endpoints consumidos:
 *  - `POST /crm/contacts/{contact_id}/send-follow-up-email`
 *  - `GET  /crm/settings/follow-up-promo`
 *  - `PUT  /crm/settings/follow-up-promo`
 */
import { api } from './api';
import { handleApiError } from '@/utils/errorHandler';
import type {
  FollowUpEmailTemplateId,
  SendFollowUpEmailResponse,
} from '@/types/followUpEmail';

interface SendArgs {
  contact_id: string;
  template_id: FollowUpEmailTemplateId;
}

async function sendFollowUpEmail({
  contact_id,
  template_id,
}: SendArgs): Promise<SendFollowUpEmailResponse> {
  try {
    const { data } = await api.post<SendFollowUpEmailResponse>(
      `/crm/contacts/${contact_id}/send-follow-up-email`,
      { template_id }
    );
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export interface FollowUpPromoResponse {
  text: string | null;
  updated_at: string | null;
  updated_by?: string | null;
}

export async function getFollowUpPromo(): Promise<FollowUpPromoResponse> {
  try {
    const { data } = await api.get<FollowUpPromoResponse>(
      '/crm/settings/follow-up-promo',
    );
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function updateFollowUpPromo(
  text: string | null,
): Promise<FollowUpPromoResponse> {
  try {
    const { data } = await api.put<FollowUpPromoResponse>(
      '/crm/settings/follow-up-promo',
      { text },
    );
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export const followUpEmailService = {
  send: sendFollowUpEmail,
};
